import React from "react";
import FiltersContext from "../FiltersContext";
import FiltersForm from "./FiltersForm";
import getAvailableOptions from "../helpers/getAvailableOptions";
import getCurrentMapPosition from "../helpers/getCurrentMapPosition";
import getSelectedRestaurants from "../helpers/getSelectedRestaurants";
import getCoords from "../helpers/getCoords";
const Filters = () => {
  return (
    <div className="filters">
      <FiltersContext.Consumer>
        {({
          data,
          setCurrentFilters,
          setAvailableOptions,
          currentMapPosition,
          setCurrentMapPosition,
          availableOptions,
          initMapPosition,
          setSelectedRestaurants
        }) => (
          <FiltersForm
            dataForm={currentFilters => {
              setCurrentFilters(currentFilters);

              setAvailableOptions(
                getAvailableOptions(currentFilters, data, availableOptions)
              );

              setCurrentMapPosition(
                getCurrentMapPosition(
                  currentFilters,
                  currentMapPosition,
                  data,
                  initMapPosition
                )
              );

              setSelectedRestaurants(
                getSelectedRestaurants(
                  getCoords(data.countries, currentFilters),
                  currentFilters
                )
              );
            }}
          />
        )}
      </FiltersContext.Consumer>
    </div>
  );
};

export default Filters;
